import { CLOSE_BUTTON } from '../constants.js';
import { findAllNode } from '../find-all-node.js';

const isClickable = (node) =>
  node.type === 'button' ||
  (node.type === 'image' && node.isClickable) ||
  node.role === 'pollOption' ||
  node.role === 'quizOption';

const byWeight = (first, second) => first.weight - second.weight;

/**
 * every slide must contain at last one clickable widget,
 * one of them must get focus.
 *
 *   - via explicit definition: isFBD = true;
 *   - via implicit election: the very first of clickable widget.
 *
 * "close" button got the very low priority and must be the latest candidate.
 */
export function patchAutoFocusable(schema) {
  const resetAutoFocus = (widget, index) => {
    schema.widgets[widget.id].autoFocus = index === 0;
  };

  schema.slides.forEach((slide) => {
    const clickable = findAllNode(slide, isClickable);
    const sorted = clickable.map(addFocusWeight).sort(byWeight);

    sorted.forEach(resetAutoFocus);

    Object.defineProperty(slide, 'autoFocusWidget', {
      get() {
        const [first] = clickable.map(addFocusWeight).sort(byWeight);
        return first?.id;
      },
    });
  });

  return schema;
}

function addFocusWeight(node) {
  let weight = 0;
  if (node.isFocusByDefault) {
    weight -= Infinity;
  }
  if (node.role === CLOSE_BUTTON) {
    weight += Infinity;
  }

  return {
    id: node.id,
    type: node.type,
    weight,
  };
}
